/** Opens the Ctrl+K palette from anywhere (e.g. the header search button). */
export const OPEN_COMMAND_PALETTE_EVENT = 'command-palette:open';

export const openCommandPalette = () =>
  window.dispatchEvent(new Event(OPEN_COMMAND_PALETTE_EVENT));

const isMac = (): boolean =>
  typeof navigator !== 'undefined' &&
  /Mac|iPhone|iPad/.test(navigator.platform);

/**
 * Ctrl+K (Windows/Linux) or ⌘K (macOS). On a Mac, Ctrl+K stays the text
 * fields' "delete to end of line".
 */
export const isPaletteShortcut = (
  event: KeyboardEvent,
  mac: boolean = isMac()
): boolean =>
  (mac ? event.metaKey : event.ctrlKey || event.metaKey) &&
  !event.altKey &&
  !event.shiftKey &&
  event.key.toLowerCase() === 'k';

/** "#1234" or "1234": an order number. */
export const orderIdFromQuery = (query: string): number | null => {
  const match = /^#?\s*(\d{1,9})$/.exec(query.trim());
  return match ? Number(match[1]) : null;
};
